import { useEffect, useRef } from "react";
import api from "./axiosInstance";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PING_INTERVAL = 2 * 60 * 1000;

export const useKeepAlive = (isAuthenticated) => {
  const lastPing = useRef(Date.now());

  useEffect(() => {
    if (!isAuthenticated) return;

    const handleActivity = async () => {
      if (Date.now() - lastPing.current > PING_INTERVAL) {
        await api.get(`${API_BASE_URL}/api/v1/auth/keep-alive`);
        lastPing.current = Date.now();
      }
    };

    ["mousemove", "scroll", "keydown", "click"].forEach(e =>
      window.addEventListener(e, handleActivity)
    );

    return () => {
      ["mousemove", "scroll", "keydown", "click"].forEach(e =>
        window.removeEventListener(e, handleActivity)
      );
    };
  }, [isAuthenticated]);
};
